import { addListener } from '../common';

export const onDocsRefetch = addListener<{
  refetch: boolean;
}>('/docs/refetch');
